import { useState } from 'react'
import styles from './LoginForm.module.css'
import PropTypes from 'prop-types'

// TODO: login service should probably belong to its parent

export const LoginForm = ({
  user,
  userLogin,
  userLogout,
}) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    !user ? userLogin(username, password) : userLogout()
    resetFields()
  }

  /* Utils */
  const resetFields = () => {
    setUsername('')
    setPassword('')
  }

  /* Renders */

  const logoutForm = () => (
    <form
      onSubmit={handleSubmit}
      className={[styles.form].join(' ')}
    >
      <p>Welcome, {user.username}</p>
      <button type="submit">logout</button>
    </form>
  )

  const loginForm = () => (
    <form
      onSubmit={handleSubmit}
      className={[styles.form].join(' ')}
    >
      <input
        id="loginUsernameInput"
        type="text"
        value={username}
        name="Username"
        onChange={({ target }) => setUsername(target.value)}
        placeholder="username"
      />
      <input
        id="loginPasswordInput"
        type="password"
        value={password}
        name="Password"
        onChange={({ target }) => setPassword(target.value)}
        placeholder="password"
      />
      <button
        id="loginSubmitButton"
        className="btn-accent-dark"
        type="submit"
      >
        login
      </button>
    </form>
  )

  return <div> {user ? logoutForm() : loginForm()}</div>
}

LoginForm.propTypes = {
  // user: PropTypes.shape({ username: PropTypes.string })
  //   .isRequired,
  userLogin: PropTypes.func.isRequired,
  userLogout: PropTypes.func.isRequired,
}
